/* global google */

import helpers from "@js/libs/helpers";
import loadjs from "loadjs";

let gmapsLoaded = false;
let map;

helpers.docReady(() => {

	const mapElement = document.getElementById('map-canvas');

	if (!mapElement) {
		return;
	} // else {
		// console.log(mapElement);
	// }

	if (!gmapsLoaded) {
		loadjs('https://maps.googleapis.com/maps/api/js?key=AIzaSyCk0hqDmGvASSSSvxzWJCjlBlzksQBQfaw&sensor=false', 'googlemaps', { async: true });
	}

	const init = function() {

		// console.log('Google Maps JS Loaded');

		const center = new google.maps.LatLng(51.540685, -0.056799);

		let mapOptions = {
			zoom: 16,
			center,
			disableDefaultUI: true,
			styles: [
				{
					"featureType": "landscape",
					"stylers": [{"saturation": -100}, {"lightness": 65}, {"visibility": "on"}]
				},
				{
					"featureType": "poi",
					"stylers": [{"saturation": -100}, {"lightness": 51}, {"visibility": "simplified"}]
				},
				{
					"featureType": "road.highway",
					"stylers": [{"saturation": -100}, {"visibility": "simplified"}]
				},
				{
					"featureType": "road.arterial",
					"stylers": [{"saturation": -100}, {"lightness": 30}, {"visibility": "on"}]
				},
				{
					"featureType": "road.local",
					"stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]
				},
				{
					"featureType": "transit",
					"stylers": [{"saturation": -100}, {"visibility": "simplified"}]
				},
				{
					"featureType": "administrative.province",
					"stylers": [{"visibility": "off"}]
				},
				{
					"featureType": "water",
					"elementType": "labels",
					"stylers": [{"visibility": "on"}, {"lightness": -25}, {"saturation": -100}]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [{"hue": "#ffff00"}, {"lightness": -25}, {"saturation": -97}]
				}
			]
		};

		map = new google.maps.Map(mapElement, mapOptions);

		let image = {
			url: '/dist/img/marker-odr.png',
			scaledSize: new google.maps.Size(62, 75)
		};

		let beachMarker = new google.maps.Marker({
			position: center,
			map,
			icon: image
		});

		// Resize snipper
		google.maps.event.addDomListener(window, "resize", function() {
			let center = map.getCenter();
			google.maps.event.trigger(map, "resize");
			map.setCenter(center);
		});

	};

	loadjs.ready('googlemaps', {
		error: err => console.log(err),
		success: () => {
			gmapsLoaded = true;
			init();
		}
	}); // end loadjs

}, 'maps');
